import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import css from "./DishAddSemiFinishModal.module.css";
import { semiFinishedActions } from "../../../../store/slices/semiFinished-slice";
import { dishSemiFinishedActions } from "../../../../store/slices/dishes-slices";

const DishUpdateSemiFinishModal = ({
    setDishSemiFinishUpdateOpen,
    semiFinishedId,
    weight,
    weightNetto,
}) => {
    const [selectedSemiFinished, setSelectedSemiFinished] = useState(null);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const { semiFinishedArray, trigger } = useSelector(store => store.semiFinished);
    const { dishSemiFinishedModalArray } = useSelector(store => store.dishSemiFinished);

    const [localWeight, setLocalWeight] = useState(weight);
    const [localWeightNetto, setLocalWeightNetto] = useState(weightNetto);

    useEffect(() => {
        dispatch(semiFinishedActions.getAllSemiFinished());
    }, [trigger, dispatch]);

    useEffect(() => {
        if (semiFinishedArray.length > 0 && semiFinishedId) {
            setSelectedSemiFinished(semiFinishedArray.find(obj => obj.id === semiFinishedId));
        }
    }, [semiFinishedArray, semiFinishedId]);

    const handleUpdateSemiFinishSubmit = async (e, data) => {
        e.preventDefault();
        try {
            if (!selectedSemiFinished) return;

            const newWeightNetto = Number(data.weightNetto);

            // Auto-calculate weight based on weightNetto and semi-finished spec
            let newWeight;
            if (data.weight && Number(data.weight) > 0) {
                newWeight = Number(data.weight);
            } else {
                const originalWeight = parseFloat(selectedSemiFinished.weight) || 0;
                const originalWeightNetto = parseFloat(selectedSemiFinished.weightNetto) || 0;
                const nettoRatio = originalWeight > 0 ? originalWeightNetto / originalWeight : 1;
                newWeight = nettoRatio > 0 ? Number((newWeightNetto / nettoRatio).toFixed(2)) : newWeightNetto;
            }

            const originalItemWeight = parseFloat(selectedSemiFinished.weight) || 100;
            const portionMultiplier = newWeight / originalItemWeight;

            // Calculate cost from component products + nested semi-finisheds
            const totalProductsCost = (selectedSemiFinished.products || []).reduce(
                (sum, p) => sum + (parseFloat(p.cost) || 0), 0
            );
            const totalChildSfCost = (selectedSemiFinished.includedSemiFinisheds || []).reduce(
                (sum, s) => sum + (parseFloat(s.cost) || 0), 0
            );
            const totalSemiFinishedCost = totalProductsCost + totalChildSfCost;

            const updatedItem = {
                id: selectedSemiFinished.id,
                name: selectedSemiFinished.name,
                weight: newWeight,
                weightNetto: newWeightNetto,
                cost: Number((totalSemiFinishedCost * portionMultiplier).toFixed(2)),
                energy: Number(((selectedSemiFinished.energy || 0) * portionMultiplier).toFixed(2)),
                fats: Number(((selectedSemiFinished.fats || 0) * portionMultiplier).toFixed(2)),
                proteins: Number(((selectedSemiFinished.proteins || 0) * portionMultiplier).toFixed(2)),
                carbohydrates: Number(((selectedSemiFinished.carbs || 0) * portionMultiplier).toFixed(2)),
            };

            const updatedArray = dishSemiFinishedModalArray.map(item => {
                if (
                    item.semiFinishedId === semiFinishedId ||
                    item.id === semiFinishedId
                ) {
                    return updatedItem;
                }
                return item;
            });

            dispatch(dishSemiFinishedActions.updateDishSemiFinishedForModal(updatedArray));
            dispatch(dishSemiFinishedActions.changeTrigger());
            setDishSemiFinishUpdateOpen(false);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <section className={css.overlay}>
            <div className={css.modal}>
                <button
                    className={css.closeButton}
                    onClick={() => setDishSemiFinishUpdateOpen(false)}
                >
                    &times;
                </button>
                <h2 className={css.title}>Update Semi Finish</h2>

                <form className={css.content}>
                    <div className={css.inputGroup}>
                        <label>{t("Semi Finished")}</label>
                        <h2>
                            {selectedSemiFinished?.name[currentLanguage] ||
                                selectedSemiFinished?.name?.["en"]}
                        </h2>
                    </div>

                    <div className={css.inputGroup}>
                        <label htmlFor="weight">{t("Weight")}</label>
                        <input
                            type="number"
                            id="weight"
                            onChange={(e) => setLocalWeight(e.target.value)}
                            value={localWeight}
                        />
                    </div>

                    <div className={css.inputGroup}>
                        <label htmlFor="weightNetto">{t("WeightNetto")}</label>
                        <input
                            type="number"
                            id="weightNetto"
                            onChange={(e) => setLocalWeightNetto(e.target.value)}
                            value={localWeightNetto}
                        />
                    </div>

                    <div className={css.actions}>
                        <button
                            type="button"
                            className={css.cancelButton}
                            onClick={() => setDishSemiFinishUpdateOpen(false)}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={css.okButton}
                            onClick={(e) =>
                                handleUpdateSemiFinishSubmit(e, {
                                    weight: localWeight,
                                    weightNetto: localWeightNetto,
                                })
                            }
                        >
                            OK
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
};

export { DishUpdateSemiFinishModal };
